export default __webpack_public_path__ + "static/media/logout.b4f0eafb.svg";